const themeFonts = {
    heading: `'Playfair Display', sans-serif`,
    body: `'Cabin Custom', sans-serif`,
    // cursive fonts
    cursive: `'Shadows Into Light', sans-serif`,
};

export default themeFonts;
